export default __webpack_public_path__ + "static/media/G_Gamba.0a8f6a34.svg";